import { BuildingCode, DesignStandard } from '@paragon/contract-library';

export type DesignCode = readonly [BuildingCode, DesignStandard];

// Server-side implementation in `IAnalyzableExtensions.cs`. You may need to update
//   `StructuralLoading.NominalLoadCauseEnumMethods.SupportedBuildingCodes` as well.
export const ValidDesignCodes: readonly DesignCode[] = [
  // IBC/IRC 2009 are quasi-supported, but we don't want them to be used for new designs. See ValidDesignCodeOptions
  //   in DesignCodeField.
  [BuildingCode.Bcnys2020, DesignStandard.Tpi2014],
  [BuildingCode.Bcnys2025, DesignStandard.Tpi2022],
  [BuildingCode.Cbc2019, DesignStandard.Tpi2014],
  [BuildingCode.Cbc2022, DesignStandard.Tpi2014],
  [BuildingCode.Cbc2025, DesignStandard.Tpi2022],
  [BuildingCode.Crc2022, DesignStandard.Tpi2014],
  [BuildingCode.Crc2025, DesignStandard.Tpi2022],
  [BuildingCode.Fbc2017, DesignStandard.Tpi2014],
  [BuildingCode.Fbc2020, DesignStandard.Tpi2014],
  [BuildingCode.Fbc2023, DesignStandard.Tpi2014],
  [BuildingCode.Fbc2026, DesignStandard.Tpi2022],
  [BuildingCode.Frc2017, DesignStandard.Tpi2014],
  [BuildingCode.Frc2020, DesignStandard.Tpi2014],
  [BuildingCode.Frc2023, DesignStandard.Tpi2014],
  [BuildingCode.Frc2026, DesignStandard.Tpi2022],
  [BuildingCode.Ibc2009, DesignStandard.Tpi2007],
  [BuildingCode.Ibc2012, DesignStandard.Tpi2007],
  [BuildingCode.Ibc2015, DesignStandard.Tpi2014],
  [BuildingCode.Ibc2018, DesignStandard.Tpi2014],
  [BuildingCode.Ibc2021, DesignStandard.Tpi2014],
  [BuildingCode.Ibc2024, DesignStandard.Tpi2022],
  [BuildingCode.Irc2009, DesignStandard.Tpi2007],
  [BuildingCode.Irc2012, DesignStandard.Tpi2007],
  [BuildingCode.Irc2015, DesignStandard.Tpi2014],
  [BuildingCode.Irc2018, DesignStandard.Tpi2014],
  [BuildingCode.Irc2021, DesignStandard.Tpi2014],
  [BuildingCode.Irc2024, DesignStandard.Tpi2022],
  [BuildingCode.Ncbc2018, DesignStandard.Tpi2014],
  [BuildingCode.Rcnys2025, DesignStandard.Tpi2022],
  [BuildingCode.Scbc2018, DesignStandard.Tpi2014],
];
